import React from 'react';
import { useSite } from '../context/SiteContext';

const Footer = () => {
  const { settings } = useSite() || {};
  const text = settings?.footerText || `© ${new Date().getFullYear()} GoGoYonoGames.com — All Rights Reserved`;
  return (
    <footer className="w-full bg-[#6a1b7d] text-white mt-6">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-white/90">{text}</p>
        <div className="flex items-center gap-4 text-sm">
          <a href="/" className="hover:text-yellow-300 transition-colors">Home</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
